import { ConstantsUtil as CommonConstantsUtil } from '@reown/appkit-common';
import { ConstantsUtil } from './ConstantsUtil.js';
export const HelpersUtil = {
    getTabsByNamespace(namespace) {
        const isEVM = Boolean(namespace) && namespace === CommonConstantsUtil.CHAIN.EVM;
        if (!isEVM) {
            return [];
        }
        return ConstantsUtil.ACCOUNT_TABS;
    }
};
//# sourceMappingURL=HelpersUtil.js.map